// Pure geometry for resizable table columns — no React/DOM, same separation
// utils/floatingWindow.js keeps between drag math and the component that
// drives it.

export const MIN_COLUMN_WIDTH = 72; // floor — enough for a short label + ellipsis
export const MAX_COLUMN_WIDTH = 2000; // defensive rail on a stored value, not a UX limit
export const DEFAULT_COLUMN_WIDTH = 160; // fallback when a column defines no defaultWidth

export function clampColumnWidth(width, min = MIN_COLUMN_WIDTH, max = MAX_COLUMN_WIDTH) {
  return Math.min(Math.max(width, min), max);
}
